import { FeatureFlag, RealmRole } from 'apps/common/src/enum';
import { Routes } from '../../../../../route/Routes';
import { getFeature } from '../../../../../util/ff/getFeature';
import { CohortType } from '@prisma/client';

export const enum NavTitles {
  CheckParticipant = 'CheckParticipant',
  PausedParticipants = 'PausedParticipants',
  Statistics = 'Statistics',
  FilterUsers = 'Filter Users',
  Home = 'Home',
  Shop = 'Shop',
  Orders = 'Orders',
  Questionnaires = 'Questionnaires',
  Versand = 'Versand',
  Profile = 'Profile',
  Inventory = 'Inventory',
  Voucher = 'Voucher',
  RaffleWinneres = 'RaffleWinners',
}

const shop =
  getFeature(FeatureFlag.Shop, [
    {
      iconName: 'shopping_bag',
      text: NavTitles.Shop,
      role: [RealmRole.Participant],
      cohortType: [CohortType.CONVENIENT_ACCESS, CohortType.ACCESS],
      route: `${Routes.Study}/${Routes.Shop}`,
    },
    {
      iconName: 'sell',
      text: NavTitles.Orders,
      role: [RealmRole.ShopEmployee, RealmRole.StudyOrganizer],
      route: `${Routes.Study}/${Routes.OpenShopOrders}`,
    },
  ]) ?? [];

export const navItems = [
  {
    iconName: 'clipboard',
    text: NavTitles.CheckParticipant,
    role: [RealmRole.StudyOrganizer, RealmRole.ShopEmployee],
    route: Routes.Study,
  },
  {
    iconName: 'warning_fill',
    text: NavTitles.PausedParticipants,
    role: [RealmRole.StudyOrganizer],
    route: `${Routes.Study}/${Routes.PausedUsers}`,
  },
  {
    iconName: 'redeem',
    text: NavTitles.RaffleWinneres,
    role: [RealmRole.StudyOrganizer, RealmRole.ShopEmployee],
    route: `${Routes.Study}/${Routes.RaffleWinners}`,
  },
  {
    iconName: 'bar_chart',
    text: NavTitles.Statistics,
    role: [RealmRole.StudyOrganizer],
    route: `${Routes.Study}/${Routes.Statistics}`,
  },
  {
    iconName: 'clock',
    text: NavTitles.FilterUsers,
    role: [RealmRole.StudyOrganizer],
    route: `${Routes.Study}/${Routes.FilterUsers}`,
  },
  {
    iconName: 'home',
    text: NavTitles.Home,
    role: [RealmRole.Participant],
    route: Routes.Study,
  },
  {
    iconName: 'voucher_nav',
    text: NavTitles.Questionnaires,
    role: [RealmRole.Participant],
    cohortType: [
      CohortType.CONVENIENT_ACCESS,
      CohortType.ACCESS,
      CohortType.CONTROL_GROUP,
    ],
    route: `${Routes.Study}/${Routes.Questionnaires}`,
  },
  {
    iconName: 'mail',
    text: NavTitles.Versand,
    role: [RealmRole.Participant],
    cohortType: [CohortType.CONVENIENT_ACCESS],
    // group B keeps its cohort type after a move, only the eligibility flips
    requiresNachversandEligible: true,
    route: `${Routes.Study}/${Routes.Versand}`,
  },
  ...shop,
  {
    iconName: 'person',
    text: NavTitles.Profile,
    role: [RealmRole.Participant],
    cohortType: [CohortType.CONVENIENT_ACCESS, CohortType.ACCESS],
    route: `${Routes.Study}/${Routes.Profile}`,
  },
  {
    iconName: 'inventory',
    text: NavTitles.Inventory,
    role: [RealmRole.StudyOrganizer],
    route: `${Routes.Study}/${Routes.Inventory}`,
  },
  {
    iconName: 'coupon',
    text: NavTitles.Voucher,
    role: [RealmRole.StudyOrganizer],
    route: `${Routes.Study}/${Routes.Voucher}`,
  },
] as NavItem[];

type NavItem = {
  iconName: string;
  text: string;
  role: RealmRole[];
  route: string;
  cohortType?: CohortType[];
  requiresNachversandEligible?: boolean;
};
